import { useMedia } from "react-use";

export const useIsMobile = (breakpoint = 768): boolean => {
  const mediaQuery = `(max-width: ${breakpoint}px)`;
  const isMobile = useMedia(mediaQuery, false);
  return isMobile;
};
